// Load the WordPress DomReady
import domReady from '@wordpress/dom-ready';

// Import Classes

// Run Classes on DomReady
domReady( function() {
} );
